e4.checkout = {
    debug: false,
    validateOptions: {
        rules: {
            'EcomOrderCustomerZip': {
                required: true,
                isValidZip: true
            },
            'EcomOrderDeliveryZip': {
                required: true,
                isValidZip: true
            }
        }
    },
    init: function () {
        if ( jQuery( '.js-e-checkout' ).length === 1 ) {
            e4.util.require.js( e4.settings.require.handlebars, function () {
                e4.checkout.event = e4.util.registerEvents( 'created orderupdate orderupdated cartupdate cartupdated alternativedeliverychange alternativedeliverychanged alternativebillingchange alternativebillingchanged deliverychange deliverychanged shippingaddresschange shippingaddresschanged stepchange stepchanged countrychange countrychanged', 'checkout' );
                e4.checkout.create();
            } );
        }
        if ( jQuery( '.js-e-checkout-receipt' ).length === 1 ) {
            e4.checkout.steps.receipt.init();
        }
    },
    create: function () {
        var jCheckout = jQuery( '.js-e-checkout' ),
                stepSetupArr = jCheckout.data( 'step-setup' ).split( ',' ),
                checkoutType = jCheckout.data( 'checkout-type' );
        e4.checkout.data = {
            type: checkoutType,
            current: {},
            target: {},
            steps: []
        };
        for ( var i = 0; i < stepSetupArr.length; i++ ) {
            e4.checkout.data.steps.push( {
                index: i,
                name: stepSetupArr[ i ]
            } );
        }
        e4.handlebars.registerHelpers( 'compare counter' );
        Handlebars.registerHelper( 'get_step', function ( name, value ) {
            return e4.checkout.utils.getStepByName( name )[ value ];
        } );
        Handlebars.registerHelper( 'get_step_number', function ( name ) {
            return e4.checkout.utils.getStepByName( name ).index + 1;
        } );
        Handlebars.registerHelper( 'if_step', function ( name, condition, options ) {
            var step = e4.checkout.utils.getStepByName( name );
            return step[ condition ] ? options.fn( this ) : options.inverse( this );
        } );
        Handlebars.registerHelper( 'unless_step', function ( name, condition, options ) {
            var step = e4.checkout.utils.getStepByName( name );
            return !step[ condition ] ? options.fn( this ) : options.inverse( this );
        } );
        e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-checkout #js-e-handlebars-tmpl-cart #js-e-handlebars-tmpl-checkout-summery' );
        e4.handlebars.registerPartials( '#js-e-handlebars-partial-gls #js-e-handlebars-partial-pacsoft' );
        jQuery( '.js-e-checkout' ).trigger( e4.checkout.event.created, { type: e4.checkout.data.type } );
        e4.checkout.bindEvents();
        var waitForjQueryValidate = setInterval( function () {
            if ( window.jQuery.fn.validate ) {
                jQuery.validator.addMethod( 'isValidZip', function ( value, element ) {
                            var pattern = e4.checkout.utils.zipPatterns[ jQuery( 'html' ).attr( 'lang' ) ] !== undefined ? e4.checkout.utils.zipPatterns[ jQuery( 'html' ).attr( 'lang' ) ]() : '';
                            return pattern.test( value );
                        }
                );

                clearInterval( waitForjQueryValidate );
            }
        }, 100 );
        e4.checkout.steps.init();
    },
    utils: {
        getStepByIndex: function ( intIndex ) {
            return e4.checkout.data.steps.filter( function ( step ) {
                return step.index === intIndex;
            } )[ 0 ];
        },
        getStepByName: function ( strName ) {
            return e4.checkout.data.steps.filter( function ( step ) {
                return step.name === strName;
            } )[ 0 ];
        },
        mapDeliveryToBilling: function () {
            var mappingObj = {
                EcomOrderCustomerName: jQuery( '[name="EcomOrderDeliveryName"]' ).val(),
                EcomOrderCustomerCompany: jQuery( '[name="EcomOrderDeliveryCompany"]' ).val(),
                EcomOrderCustomerAddress: jQuery( '[name="EcomOrderDeliveryAddress"]' ).val(),
                EcomOrderCustomerAddress2: jQuery( '[name="EcomOrderDeliveryAddress2"]' ).val(),
                EcomOrderCustomerZip: jQuery( '[name="EcomOrderDeliveryZip"]' ).val(),
                EcomOrderCustomerCity: jQuery( '[name="EcomOrderDeliveryCity"]' ).val(),
                EcomOrderCustomerCountry: jQuery( '[name="EcomOrderDeliveryCountry"]' ).val(),
                EcomOrderCustomerPhone: jQuery( '[name="EcomOrderDeliveryPhone"]' ).val()
            };
            if ( e4.checkout.debug === true ) {
                console.log( 'Mapping delivery to billing' );
            }
            e4.checkout.utils.mapAddress( mappingObj );
        },
        mapBillingToDelivery: function () {
            var mappingObj = {
                EcomOrderDeliveryName: jQuery( '[name="EcomOrderCustomerName"]' ).val(),
                EcomOrderDeliveryCompany: jQuery( '[name="EcomOrderCustomerCompany"]' ).val(),
                EcomOrderDeliveryAddress: jQuery( '[name="EcomOrderCustomerAddress"]' ).val(),
                EcomOrderDeliveryAddress2: jQuery( '[name="EcomOrderCustomerAddress2"]' ).val(),
                EcomOrderDeliveryZip: jQuery( '[name="EcomOrderCustomerZip"]' ).val(),
                EcomOrderDeliveryCity: jQuery( '[name="EcomOrderCustomerCity"]' ).val(),
                EcomOrderDeliveryCountry: jQuery( '[name="EcomOrderCustomerCountry"]' ).val(),
                EcomOrderDeliveryPhone: jQuery( '[name="EcomOrderCustomerPhone"]' ).val()
            };
            if ( e4.checkout.debug === true ) {
                console.log( 'Mapping billing to delivery' );
            }
            e4.checkout.utils.mapAddress( mappingObj );
        },
        mapAddress: function ( objMapping ) {
            Object.keys( objMapping ).map( function ( inputName ) {
                if ( objMapping[ inputName ] ) {
                    jQuery( '[name="' + inputName + '"]' ).val( objMapping[ inputName ] );
                }
            } );
        },
        zipPatterns: {
            da: function () {
                return /^\d{3,4}$/;
            },
            nb: function () {
                return /^\d{4}$/;
            },
            sv: function () {
                return /\d{3}\s?\d{2}/
            },
            de: function () {
                return /^\d{5}$/
            }
        }

    },
    bindEvents: function () {
        var jCheckout = jQuery( '.js-e-checkout' );
        /* Espresso events */
        jCheckout.on( e4.checkout.event.orderupdate, function ( event, data ) {
            if ( e4.checkout.debug === true ) {
                console.log( 'Running event: orderupdate' );
            }
            e4.checkout.order.fetch( event, data );
        } ).on( e4.checkout.event.orderupdated, function ( event ) {
            if ( e4.checkout.debug === true ) {
                console.log( 'Running event: orderupdated' );
            }
            e4.checkout.steps.change( event );
        } ).on( e4.checkout.event.cartupdate, function () {
            if ( e4.checkout.debug === true ) {
                console.log( 'Running event: cartupdate' );
            }
            e4.checkout.cart.fetch();
        } ).on( e4.checkout.event.countrychange, function ( event, data ) {
            if ( e4.checkout.debug === true ) {
                console.log( 'Running event: countrychange' );
            }
            e4.checkout.order.fetch( event, data );
            e4.checkout.cart.fetch();
        } ).on( e4.checkout.event.stepchange, function ( event, data ) {
            if ( e4.checkout.debug === true ) {
                console.log( 'Running event: stepchange' );
            }
            e4.checkout.data.target = e4.checkout.utils.getStepByName( data.step.name );
            e4.util.hash.set( 'step', data.step.name );
        } ).on( e4.checkout.event.deliverychange, function ( event, data ) {
            if ( e4.checkout.debug === true ) {
                console.log( 'Running event: deliverychange' );
            }
            e4.checkout.steps.shipping.changeDelivery( event, data );
        } ).on( e4.checkout.event.shippingaddresschange, function ( event ) {
            if ( e4.checkout.debug === true ) {
                console.log( 'Running event: shippingaddresschange' );
            }
            if ( e4.checkout.data.type === 'b2b' ) {
                e4.checkout.steps.shipping.handleAdresses( event );
            }
        } ).on( e4.checkout.event.alternativedeliverychange, function ( event ) {
            if ( e4.checkout.debug === true ) {
                console.log( 'Running event: alternativedeliverychange' );
            }
            e4.checkout.steps.shipping.alternativeDelivery( event );
        } ).on( e4.checkout.event.alternativebillingchange, function ( event ) {
            if ( e4.checkout.debug === true ) {
                console.log( 'Running event: alternativebillingchange' );
            }
            e4.checkout.steps.customer.alternativeBilling( event );
        } );
        /* Bind router */
        jQuery( window ).on( 'hashchange', function () {
            var hashStep = e4.util.hash.get( 'step' );
            if ( hashStep !== undefined ) {
                var updateObj = {
                    step: e4.checkout.utils.getStepByName( hashStep ),
                    delay: e4.settings.ecom.checkout.delay
                };
                jCheckout.trigger( e4.checkout.event.orderupdate, updateObj );
            }
        } );
        if ( e4.util.hash.get( 'step' ) === undefined ) {
            e4.util.hash.replace( 'step', e4.checkout.data.steps[ 0 ].name );
            e4.checkout.data.current = e4.checkout.data.steps[ 0 ];
            e4.checkout.data.target = e4.checkout.data.steps[ 0 ];
        }
        else {
            jQuery( window ).triggerHandler( 'hashchange' );
        }
        /* Collapse events */
        jCheckout.on( 'shown.bs.collapse', '.collapse', function ( event ) {
            jQuery( event.currentTarget ).find( 'form' ).validate( e4.checkout.validateOptions );
        } ).on( 'hidden.bs.collapse', '.collapse', function () {
            if ( e4.checkout.data.current !== e4.checkout.data.target ) {
                if ( Math.max( jQuery( window ).width(), window.innerWidth ) > e4.settings.breakpoint[ e4.settings.ecom.checkout.multipageBreakpoint ] ) {
                    e4.scrollToAnchor.animate( e4.scrollToAnchor.getTarget( '.js-e-checkout-step[data-step="' + e4.checkout.data.target + '"]:first' ) - jQuery( '.js-e-header' ).height(), e4.header.hide );
                }
            }
        } ).on( 'hide.bs.collapse', '.collapse', function () {
            if ( e4.checkout.data.current !== e4.checkout.data.target ) {
                if ( Math.max( jQuery( window ).width(), window.innerWidth ) <= e4.settings.breakpoint[ e4.settings.ecom.checkout.multipageBreakpoint ] ) {
                    jQuery( window ).scrollTop( 0 );
                }
            }
        } );
        /* Click events */
        jCheckout.on( 'click', '.js-e-checkout-change-step', function ( event ) {
            event.preventDefault();
            var currentStep = e4.checkout.utils.getStepByName( e4.util.hash.get( 'step' ) ),
                    jStep = jQuery( this ).data( 'direction' ) === 'next' ? e4.checkout.utils.getStepByIndex( parseInt( currentStep.index ) + 1 ) : e4.checkout.utils.getStepByIndex( parseInt( currentStep.index ) - 1 ),
                    jForm = jQuery( this ).closest( 'form' );
            if ( jForm.valid() === true ) {
                jCheckout.trigger( e4.checkout.event.stepchange, { step: jStep } );
            }
        } ).on( 'click', '.js-e-checkout-edit-step', function ( event ) {
            event.preventDefault();
            var jStep = e4.checkout.utils.getStepByName( jQuery( this ).data( 'target' ).replace( '#', '' ) );
            jCheckout.trigger( e4.checkout.event.stepchange, { step: jStep } );
        } ).on( 'click', '.js-e-checkout-update-cart', function () {
            jQuery( '.js-e-checkout' ).trigger( e4.checkout.event.cartupdate );
        } ).on( 'click', '.js-e-checkout-update-order', function () {
            jQuery( '.js-e-checkout' ).trigger( e4.checkout.event.orderupdate );
        } );
        /* Change events */
        jCheckout.on( 'change', '.js-e-checkout-company-toggle', function ( event ) {
            event.preventDefault();
            jQuery( this ).closest( '.js-e-checkout-step-form' ).find( '.js-company-label-toggle' ).toggle();
            jQuery( this ).closest( '.js-e-checkout-step-form' ).find( '.js-e-checkout-company-address-fieldset' ).slideToggle( e4.settings.animation.speed );
            if ( jQuery( this ).val() === 'private' ) {
                jQuery( this ).closest( '.js-e-checkout-step-form' ).find( '.js-company-control-value' ).val( '' );
            }
        } ).on( 'change', '.js-e-checkout-toggle-field', function ( event ) {
            event.preventDefault();
            var jToggleField = jQuery( this ).val(),
                    jTarget = jQuery( '.js-e-checkout-toggle-target[data-target="' + jToggleField + '"]' );
            jTarget.slideToggle( e4.settings.animation.speed );
            if ( jQuery( this ).is( ':checked' ) === false ) {
                jTarget.find( 'input, textarea' ).val( '' );
            }
        } ).on( 'change', '.js-e-checkout-update-country', function () {
            jQuery( '.js-e-checkout' ).trigger( e4.checkout.event.countrychange );
        } );

        /*
         jCheckout.on('blur', 'input[name=""EcomOrderDeliveryZip], input[name="EcomOrderCustomerZip"]', function(){
         var lang = jQuery('html').attr('lang'),
         zip = jQuery(this).val(),
         isValid = e4.checkout.utils.validatePostalCode(zip, lang);
         console.log(isValid);
         });
         */
        jCheckout.trigger( e4.checkout.event.cartupdate );
    },
    ajax: function ( objAjaxSettings, fnCallback ) {
        var jqXHR = jQuery.ajax( jQuery.extend( {
            url: e4.settings.ecom.checkout.url,
            method: 'POST',
            dataType: 'json',
            cache: false
        }, objAjaxSettings ) );
        jqXHR.done( function ( data ) {
            if ( typeof fnCallback === 'function' ) {
                fnCallback( data );
            }
        } ).fail( function ( error ) {
            console.error( error );
        } );
    },
    cart: {
        fetch: function () {
            e4.checkout.ajax( {
                url: e4.settings.ecom.cart.url,
                beforeSend: function () {
                    jQuery( '.js-e-checkout-cart-loading-overlay' ).addClass( 'is-loading' );
                },
                data: jQuery( '.js-e-checkout-step-form' ).serialize()
            }, function ( data ) {
                e4.checkout.cart.build( data );
                if ( e4.checkout.debug === true ) {
                    console.log( data.cart );
                }
            } );
        },
        build: function ( objData ) {
            setTimeout( function () {
                jQuery( '#js-e-checkout-cart' ).html( e4.handlebars.tmpl.cart( objData ) );
                e4.loading.resolveWait( '#js-e-checkout-cart' );
                jQuery( '.js-e-checkout' ).trigger( e4.checkout.event.cartupdated );
            }, e4.settings.ecom.checkout.delay );
        }
    },
    order: {
        fetch: function ( event, objData ) {
            if ( objData === undefined ) {
                objData = {
                    step: e4.checkout.utils.getStepByName( e4.util.hash.get( 'step' ) ),
                    delay: e4.settings.ecom.checkout.delay
                };
            }
            e4.checkout.ajax( {
                beforeSend: function () {
                    jQuery( '.js-e-checkout-step-loading-overlay' ).addClass( 'is-loading' );
                },
                data: jQuery( '.js-e-checkout-step-form' ).serialize()
            }, function ( data ) {
                //if ( e4.checkout.order.isPreviosStepsCompleted( data ) === true ) {
                e4.checkout.steps.update( objData );
                e4.checkout.order.dataHandler( data, objData.delay );
                //}
                if ( e4.checkout.debug === true ) {
                    console.log( data.order );
                    console.log( data.steps );
                }
            } );
        },
        dataHandler: function ( objData, intDelay ) {
            var glsShippingID = jQuery( '.js-e-checkout-shipping-id-gls' ).val(),
                    pacsoftShippingID = jQuery( '.js-e-checkout-shipping-id-pacsoft' ).val();
            if ( objData.steps.shipping.shippingmethodID === glsShippingID ) {
                objData.steps.shipping.isGLS = true;
                objData.steps.shipping.isPacsoft = false;
                objData.steps.shipping.isStandard = false;
                objData.steps.shipping.alternativeDeliveryAddress = true;
                objData.steps.customer.alternativeBillingAddress = true;
            }
            else if ( objData.steps.shipping.shippingmethodID === pacsoftShippingID ) {
                objData.steps.shipping.isPacsoft = true;
                objData.steps.shipping.isStandard = false;
                objData.steps.shipping.isGLS = false;
                objData.steps.shipping.alternativeDeliveryAddress = true;
                objData.steps.customer.alternativeBillingAddress = true;
            }
            else {
                objData.steps.shipping.isStandard = true;
                objData.steps.shipping.isPacsoft = false;
                objData.steps.shipping.isGLS = false;
                objData.steps.shipping.alternativeDeliveryAddress = false;
            }
            if ( objData.order.shippingmethods.length === 0 ) {
                console.error( 'No available Shipping methods on checkout module. Default method applied.' );
            }
            if ( objData.order.paymethods.length === 0 ) {
                console.error( 'No available Payment methods on checkout module.  Default method applied.' );
            }
            /*
             if ( data.steps.index <= 1 ) {
             for ( var i = 0; i < data.steps.progress.length; i++ ) {
             e4.checkout.steps.map[ data.steps.progress[ i ].name ] = data.steps.progress[ i ].index;
             }
             }
             */
            e4.checkout.order.build( objData, intDelay );
        },
        build: function ( objData, strStep, intDelay ) {
            setTimeout( function () {
                var dataObj = {
                    remote: objData,
                    steps: e4.checkout.data.steps
                };
                console.log( dataObj );
                jQuery( '#js-e-checkout-form' ).html( e4.handlebars.tmpl.checkout( dataObj ) );
                e4.loading.resolveWait( '#js-e-checkout-form' );
                jQuery( '.js-e-checkout' ).trigger( e4.checkout.event.orderupdated, objData );
            }, intDelay );
        }
    },
    steps: {
        init: function () {
            e4.checkout.steps.shipping.init();
            e4.checkout.steps.customer.init();
            e4.checkout.steps.approve.init();
        },
        update: function ( objData ) {
            var steps = e4.checkout.data.steps;
            e4.checkout.data.target = objData.step;
            if ( e4.checkout.data.current === undefined ) {
                e4.checkout.data.current = objData.step;
            }
            jQuery( '.js-e-checkout-step-previous' ).val( e4.checkout.data.current.name );
            jQuery( '.js-e-checkout-step-current' ).val( e4.checkout.data.target.name );
            for ( var i = 0; i < steps.length; i++ ) {
                if ( i < e4.checkout.data.target.index ) {
                    steps[ i ].isCurrent = false;
                    steps[ i ].isCompleted = true;
                    steps[ i ].isPrev = false;
                }
                else if ( i === e4.checkout.data.target.index ) {
                    steps[ i ].isCurrent = true;
                    steps[ i ].isCompleted = false;
                    steps[ i ].isPrev = false;
                }
                else {
                    steps[ i ].isCurrent = false;
                    steps[ i ].isCompleted = false;
                    steps[ i ].isPrev = false;
                }
            }
            e4.checkout.data.current = e4.checkout.data.target;
        },
        change: function () {
            //e4.checkout.steps.handler.methodChange( e4.checkout.data.current );
            var jCollapse = jQuery( '#js-e-checkout-accordion' );
            jCollapse.find( '.collapse.js-e-checkout-collapse-hide' ).collapse( 'hide' );
            jCollapse.find( '.collapse.js-e-checkout-collapse-show' ).collapse( 'show' );
            if ( e4.checkout.steps[ e4.checkout.data.target.name ] !== undefined ) {
                if ( e4.checkout.steps[ e4.checkout.data.target.name ].show !== undefined ) {
                    e4.checkout.steps[ e4.checkout.data.target.name ].show();
                }
            }
            jQuery( 'body' ).attr( 'class', 'e-checkout-page e-checkout-page-' + e4.checkout.data.target.name );
            e4.checkout.tracking.step( e4.checkout.data.target );
            jQuery( '.js-e-checkout' ).trigger( e4.checkout.event.stepchanged, { step: e4.checkout.data.target } );
        },
        customer: {
            init: function () {
                e4.checkout.steps.customer.bindEvents();
            },
            show: function () {
                if ( e4.checkout.data.type === 'b2c' ) {
                    jQuery( '.js-e-checkout' ).trigger( e4.checkout.event.alternativebillingchange );
                }
            },
            clear: function () {
                var jBillingForm = jQuery( '.js-e-checkout-alternative-billing-address' );
                jBillingForm.find( 'input[type="text"], input[type="number"]' ).val( '' );
                jBillingForm.find( 'input[type="checkbox"]' ).prop( 'checked', false );
                jBillingForm.find( '.js-e-checkout-toggle-target' ).hide();
            },
            bindEvents: function () {
                jQuery( '.js-e-checkout' ).on( 'change', '.js-e-checkout-has-alternative-billing-address', function ( event ) {
                    e4.checkout.steps.customer.alternativeBilling( event );
                } );
            },
            alternativeBilling: function ( event ) {
                var isTriggered = event.type === 'alternativebillingchange',
                        jAlternativeBillingAddress = jQuery( '.js-e-checkout-has-alternative-billing-address:checked' );
                if ( jAlternativeBillingAddress.val() === 'yes' ) {
                    if ( isTriggered === false ) {
                        e4.checkout.steps.customer.clear();
                    }
                    jQuery( '.js-e-checkout-alternative-billing-address' ).collapse( 'show' );
                    e4.scrollToAnchor.animate( e4.scrollToAnchor.getTarget( '.js-e-checkout-alternative-billing-address' ) );
                }
                else {
                    jQuery( '.js-e-checkout-alternative-billing-address' ).collapse( 'hide' );
                    e4.checkout.utils.mapDeliveryToBilling();
                }
                jQuery( '.js-e-checkout' ).trigger( e4.checkout.event.alternativebillingchanged );
            }
        },
        shipping: {
            init: function () {
                e4.checkout.steps.shipping.bindEvents();
            },
            show: function () {
                jQuery( '.js-e-checkout' ).trigger( e4.checkout.event.shippingaddresschange );
                e4.checkout.steps.shipping.gls.init();
                e4.checkout.steps.shipping.pacsoft.init();
            },
            clear: function () {
                var jDeliveryForm = jQuery( '.js-e-checkout-delivery-address' );
                jDeliveryForm.find( 'input[type="text"], input[type="number"], select' ).val( '' );
                jDeliveryForm.find( 'input[type="checkbox"]' ).prop( 'checked', false );
                jDeliveryForm.find( '.js-e-checkout-toggle-target' ).hide();
            },
            bindEvents: function () {
                jQuery( '.js-e-checkout' ).on( 'change', '.js-e-checkout-shipping-method', function () {
                    var dataObj = {
                        shippingID: jQuery( this ).val()
                    };
                    jQuery( '.js-e-checkout' ).trigger( e4.checkout.event.deliverychange, dataObj );
                } ).on( 'click', '.js-e-checkout-shippingmethod-pacsoft-lookup-btn', function () {
                    var jSearchValue = jQuery( '.js-e-checkout-shippingmethod-pacsoft-zip' ).val();
                    e4.checkout.steps.shipping.pacsoft.search( jSearchValue );
                } ).on( 'click', '.js-e-checkout-shippingmethod-gls-lookup-btn', function () {
                    var jSearchValue = jQuery( '.js-e-checkout-shippingmethod-gls-zip' ).val();
                    e4.checkout.steps.shipping.gls.search( jSearchValue );
                } ).on( 'click', '.js-e-checkout-shippingmethod-gls-result-item', function () {
                    var parcelShopID = jQuery( this ).val();
                    e4.checkout.steps.shipping.gls.set( parcelShopID );
                } ).on( 'click', '.js-e-checkout-shippingmethod-pacsoft-result-item', function () {
                    var servicePointID = jQuery( this ).val();
                    e4.checkout.steps.shipping.pacsoft.set( servicePointID );
                } ).on( 'change', '.js-e-checkout-has-alternative-delivery-address', function ( event ) {
                    e4.checkout.steps.shipping.alternativeDelivery( event );
                } ).on( 'click', '.js-e-checkout-set-delivery-address', function ( event ) {
                    e4.checkout.steps.shipping.handleAdresses( event );
                } ).on( 'input', '.js-search-user-addresses-input', function ( event ) {
                        e4.checkout.steps.shipping.searchAddresses( event );
                } ).on( 'click', '.js-search-user-addresses-input-clear', function ( event ) {
                    jQuery('.js-search-user-addresses-input').val('').trigger('input'); 
                } );
            },
            searchAddresses: function(event){
                jQuery('.js-e-checkout-shipping-user-address-item').each(function(){
                    var userAddress = jQuery(this),
                        userAddressText = userAddress.find('.js-e-checkout-shipping-user-address-item-text').text().toLowerCase();
                    if(event.target.value.length > 0){
                        jQuery(event.target).closest('.js-search-user-addresses').removeClass('is-empty');
                        if(userAddressText.indexOf(event.target.value.toLowerCase()) > -1){
                            userAddress.show();
                        } else{
                            userAddress.hide();
                        }
                    } else{
                        jQuery(event.target).closest('.js-search-user-addresses').addClass('is-empty');
                        userAddress.show();
                    }
                    
                });
            },
            alternativeDelivery: function ( event ) {
                var isTriggered = event.type === 'alternativedeliverychange',
                        jAlternativeDeliveryAddress = jQuery( '.js-e-checkout-has-alternative-delivery-address:checked' );
                if ( jAlternativeDeliveryAddress.val() === 'yes' ) {
                    if ( isTriggered === false ) {
                        e4.checkout.steps.shipping.clear();
                    }
                    jQuery( '.js-e-checkout-delivery-address' ).collapse( 'show' );
                    e4.scrollToAnchor.animate( e4.scrollToAnchor.getTarget( '.js-e-checkout-delivery-address' ) );
                }
                else {
                    jQuery( '.js-e-checkout-delivery-address' ).collapse( 'hide' );
                    e4.checkout.utils.mapBillingToDelivery();
                }
                jQuery( '.js-e-checkout' ).trigger( e4.checkout.event.alternativedeliverychanged );
            },
            changeDelivery: function ( event, objData ) {
                var pacsoftShippingID = jQuery( '.js-e-checkout-shipping-id-pacsoft' ).val(),
                        glsShippingID = jQuery( '.js-e-checkout-shipping-id-gls' ).val();
                if ( objData.shippingID === pacsoftShippingID ) {
                    e4.checkout.steps.shipping.pacsoft.show();
                    e4.checkout.steps.shipping.gls.hide();
                    e4.checkout.steps.shipping.standard.hide();
                }
                else if ( objData.shippingID === glsShippingID ) {
                    e4.checkout.steps.shipping.gls.show();
                    e4.checkout.steps.shipping.pacsoft.hide();
                    e4.checkout.steps.shipping.standard.hide();
                }
                else {
                    e4.checkout.steps.shipping.pacsoft.hide();
                    e4.checkout.steps.shipping.gls.hide();
                    e4.checkout.steps.shipping.standard.show();
                }
                jQuery( '.js-e-checkout' ).trigger( e4.checkout.event.deliverychanged );
            },
            handleAdresses: function ( event ) {
                var isTriggered = event.type === 'shippingaddresschange',
                        jCheckedAddress = jQuery( '.js-e-checkout-set-delivery-address:checked' );
                if ( jQuery( '.js-e-checkout-set-delivery-address' ).length > 0 ) {
                    if ( jCheckedAddress.val() === '999' ) {
                        if ( !isTriggered ) {
                            e4.checkout.steps.shipping.clear();
                        }
                        jQuery( '.js-e-checkout-delivery-address' ).collapse( 'show' );
                    }
                    else {
                        jQuery( '.js-e-checkout-delivery-address' ).collapse( 'hide' );
                        var mappingItems = jCheckedAddress.closest( '.js-e-checkout-shipping-user-address-item' ).find( '.js-e-checkout-set-delivery-address-mapping-data' ),
                                mappingObj = {
                                    EcomOrderDeliveryName: mappingItems.find( '[data-item="EcomOrderDeliveryName"]' ).text(),
                                    EcomOrderDeliveryCompany: mappingItems.find( '[data-item="EcomOrderDeliveryCompany"]' ).text(),
                                    EcomOrderDeliveryAddress: mappingItems.find( '[data-item="EcomOrderDeliveryAddress"]' ).text(),
                                    EcomOrderDeliveryAddress2: mappingItems.find( '[data-item="EcomOrderDeliveryAddress2"]' ).text(),
                                    EcomOrderDeliveryZip: mappingItems.find( '[data-item="EcomOrderDeliveryZip"]' ).text(),
                                    EcomOrderDeliveryCity: mappingItems.find( '[data-item="EcomOrderDeliveryCity"]' ).text(),
                                    EcomOrderDeliveryCountry: mappingItems.find( '[data-item="EcomOrderDeliveryCountry"]' ).text(),
                                    EcomOrderDeliveryPhone: mappingItems.find( '[data-item="EcomOrderDeliveryPhone"]' ).text(),
                                    EcomOrderDeliveryEmail: mappingItems.find( '[data-item="EcomOrderDeliveryEmail"]' ).text()
                                };
                        e4.checkout.steps.shipping.clear();
                        e4.checkout.utils.mapAddress( mappingObj );
                        if ( !isTriggered ) {
                            jQuery( '.js-e-checkout' ).trigger( e4.checkout.event.orderupdate );
                        }
                    }
                    jQuery( '.js-e-checkout' ).trigger( e4.checkout.event.shippingaddresschanged );
                }
            },
            standard: {
                init: function () {
                },
                show: function () {
                    jQuery( '.js-e-checkout-delivery-address' ).collapse( 'show' );
                },
                hide: function () {
                    jQuery( '.js-e-checkout-delivery-address' ).collapse( 'hide' );
                    e4.checkout.steps.shipping.clear();
                }
            },
            pacsoft: {
                init: function () {
                    e4.checkout.steps.shipping.pacsoft.bindEvents();
                    if ( e4.checkout.steps.shipping.pacsoft.data ) {
                        jQuery( '#js-e-checkout-shippingmethod-pacsoft-results' ).html( e4.handlebars.partial.pacsoft( e4.checkout.steps.shipping.pacsoft.data ) );
                        jQuery( '.js-e-checkout-shippingmethod-pacsoft-zip' ).data( 'rule-required', false );
                    }
                },
                show: function () {
                    jQuery( '.js-e-checkout-shippingmethod-pacsoft' ).collapse( 'show' );
                },
                hide: function () {
                    jQuery( '.js-e-checkout-shippingmethod-pacsoft' ).collapse( 'hide' );
                    e4.checkout.steps.shipping.pacsoft.clear();
                },
                clear: function () {
                    e4.checkout.steps.shipping.clear();
                    jQuery( '.js-e-checkout-shippingmethod-pacsoft-id' ).val( '' );
                    jQuery( '.js-e-checkout-shippingmethod-pacsoft-search-string' ).val( '' );
                    e4.checkout.steps.shipping.pacsoft.data = null;
                    jQuery( '.js-e-checkout-shippingmethod-pacsoft-zip' ).data( 'rule-required', true );
                    jQuery( '#js-e-checkout-shippingmethod-pacsoft-results' ).slideUp( e4.settings.animation.speed, function () {
                        jQuery( this ).html( '' );
                    } );
                },
                bindEvents: function () {
                    jQuery( '.js-e-checkout' ).on( 'keydown blur', '.js-e-checkout-shippingmethod-pacsoft-zip', function ( event ) {
                        var jSearchValue = jQuery( this ).val(),
                            keyPressed = event.which === 13 || event.which === 9;
                        jQuery( '.js-e-checkout-shippingmethod-pacsoft-search-string' ).val( jSearchValue + ' ' + jQuery( '.js-e-checkout-shippingmethod-pacsoft-address' ).val() );
                        if ( jSearchValue.length > 3 ) {
                            if (keyPressed) {
                                jQuery(this).trigger('blur');
                            }
                            if ( event.type === 'focusout' ) {
                                e4.checkout.steps.shipping.pacsoft.search( jSearchValue );
                            }
                        }
                    } ).on( 'keydown blur', '.js-e-checkout-shippingmethod-pacsoft-address', function ( event ) {
                        var jSearchValue = jQuery( this ).val(),
                            keyPressed = event.which === 13 || event.which === 9;
                        jQuery( '.js-e-checkout-shippingmethod-pacsoft-search-string' ).val( jQuery( '.js-e-checkout-shippingmethod-pacsoft-zip' ).val() + ' ' + jSearchValue );
                        if ( jQuery( '.js-e-checkout-shippingmethod-pacsoft-zip' ).val() && jSearchValue.length > 3 ) {
                            if (keyPressed) {
                                jQuery(this).trigger('blur');
                            }
                            if ( event.type === 'focusout' ) {
                                e4.checkout.steps.shipping.pacsoft.search( jQuery( '.js-e-checkout-shippingmethod-pacsoft-zip' ).val() );
                            }
                        }
                    } ).on( 'click', '.js-e-checkout-shippingmethod-pacsoft-edit-btn', function ( event ) {
                        event.preventDefault();
                        e4.checkout.steps.shipping.pacsoft.clear();
                        jQuery( window ).triggerHandler( 'hashchange' );
                    } );
                },
                set: function ( strServicePointID ) {
                    for ( var i = 0; i < e4.checkout.steps.shipping.pacsoft.data.servicePoints.length; i++ ) {
                        e4.checkout.steps.shipping.pacsoft.data.servicePoints[ i ].isSelected = '';
                        if ( e4.checkout.steps.shipping.pacsoft.data.servicePoints[ i ].servicePointId === strServicePointID ) {
                            var mappingObj = {
                                EcomOrderDeliveryName: e4.checkout.steps.shipping.pacsoft.data.servicePoints[ i ].name,
                                EcomOrderDeliveryCompany: e4.checkout.steps.shipping.pacsoft.data.servicePoints[ i ].name,
                                EcomOrderDeliveryAddress: e4.checkout.steps.shipping.pacsoft.data.servicePoints[ i ].deliveryAddress.streetName + ' ' + e4.checkout.steps.shipping.pacsoft.data.servicePoints[ i ].deliveryAddress.streetNumber,
                                EcomOrderDeliveryZip: e4.checkout.steps.shipping.pacsoft.data.servicePoints[ i ].deliveryAddress.postalCode,
                                EcomOrderDeliveryCity: e4.checkout.steps.shipping.pacsoft.data.servicePoints[ i ].deliveryAddress.city
                            };
                            e4.checkout.steps.shipping.pacsoft.data.servicePoints[ i ].isSelected = true;
                            e4.checkout.steps.shipping.clear();
                            e4.checkout.utils.mapAddress( mappingObj );
                            jQuery( '.js-e-checkout-shippingmethod-pacsoft-id' ).val( e4.checkout.steps.shipping.pacsoft.data.servicePoints[ i ].servicePointId );
                        }
                        jQuery( '.js-e-checkout-shippingmethod-pacsoft-zip' ).data( 'rule-required', false );
                    }
                },
                search: function ( intPacsoftZip ) {
                    var pacsoftAddress = jQuery( '.js-e-checkout-shippingmethod-pacsoft-address' ).val();
                    jQuery.ajax( {
                        url: '/pnlookup.ashx',
                        type: 'POST',
                        beforeSend: function () {
                            jQuery( '.js-e-checkout-step-loading-overlay' ).addClass( 'is-loading' );
                        },
                        data: {
                            countryCode: jQuery( '#EcomOrderDeliveryCountry' ).val(),
                            numberOfServicePoints: e4.settings.ecom.checkout.shipping.searchCount,
                            postalCode: intPacsoftZip,
                            streetName: pacsoftAddress
                        }
                    } )
                          .done( function ( data ) {
                              if ( e4.checkout.debug === true ) {
                                  console.info( data );
                              }
                              e4.checkout.steps.shipping.pacsoft.data = data.servicePointInformationResponse;
                              jQuery( '.js-e-checkout-step-loading-overlay' ).removeClass( 'is-loading' );
                              e4.checkout.steps.shipping.pacsoft.build();
                          } );
                },
                build: function () {
                    jQuery( '#js-e-checkout-shippingmethod-pacsoft-results' ).html( e4.handlebars.partial.pacsoft( e4.checkout.steps.shipping.pacsoft.data ) ).slideDown( e4.settings.animation.speed, function () {
                        e4.scrollToAnchor.animate( e4.scrollToAnchor.getTarget( '.js-e-checkout-shippingmethod-pacsoft' ) );
                    } );
                }
            },
            gls: {
                init: function () {
                    e4.checkout.steps.shipping.gls.bindEvents();
                    if ( e4.checkout.steps.shipping.gls.data ) {
                        jQuery( '#js-e-checkout-shippingmethod-gls-results' ).html( e4.handlebars.partial.gls( e4.checkout.steps.shipping.gls.data ) );
                        jQuery( '.js-e-checkout-shippingmethod-gls-zip' ).data( 'rule-required', false );
                    }
                },
                show: function () {
                    jQuery( '.js-e-checkout-shippingmethod-gls' ).on( 'shown.bs.collapse', function () {
                        if ( jQuery( '.js-e-checkout-shippingmethod-gls-zip' ).val() ) {
                            jQuery( '.js-e-checkout-shippingmethod-gls-zip' ).trigger( 'keyup' );
                        }
                    } ).collapse( 'show' );
                },
                hide: function () {
                    jQuery( '.js-e-checkout-shippingmethod-gls' ).collapse( 'hide' );
                    e4.checkout.steps.shipping.gls.clear();
                },
                clear: function () {
                    e4.checkout.steps.shipping.clear();
                    jQuery( '.js-e-checkout-shippingmethod-gls-id' ).val( '' );
                    jQuery( '.js-e-checkout-shippingmethod-gls-search-string' ).val( '' );
                    e4.checkout.steps.shipping.gls.data = null;
                    jQuery( '.js-e-checkout-shippingmethod-gls-zip' ).data( 'rule-required', true );
                    jQuery( '#js-e-checkout-shippingmethod-gls-results' ).slideUp( e4.settings.animation.speed, function () {
                        jQuery( this ).html( '' );
                    } );
                },
                bindEvents: function () {
                    jQuery( '.js-e-checkout' ).on( 'keydown blur', '.js-e-checkout-shippingmethod-gls-zip', function ( event ) {
                        var jSearchValue = jQuery( this ).val();
                        jQuery( '.js-e-checkout-shippingmethod-gls-search-string' ).val( jSearchValue + ' ' + jQuery( '.js-e-checkout-shippingmethod-gls-address' ).val() );
                        if ( jSearchValue.length > 3 ) {
                            if ( event.which === 9 || event.which === 13 || event.type === 'focusout' ) {
                                e4.checkout.steps.shipping.gls.search( jSearchValue );
                            }
                        }
                    } ).on( 'keydown blur', '.js-e-checkout-shippingmethod-gls-address', function ( event ) {
                        var jSearchValue = jQuery( this ).val();
                        jQuery( '.js-e-checkout-shippingmethod-gls-search-string' ).val( jQuery( '.js-e-checkout-shippingmethod-gls-zip' ).val() + ' ' + jSearchValue );
                        if ( jQuery( '.js-e-checkout-shippingmethod-gls-zip' ).val() && jSearchValue.length > 3 ) {
                            if ( event.which === 9 || event.which === 13 || event.type === 'focusout' ) {
                                e4.checkout.steps.shipping.gls.search( jQuery( '.js-e-checkout-shippingmethod-gls-zip' ).val() );
                            }
                        }
                    } ).on( 'click', '.js-e-checkout-shippingmethod-gls-edit-btn', function ( event ) {
                        event.preventDefault();
                        e4.checkout.steps.shipping.gls.clear();
                        jQuery( window ).triggerHandler( 'hashchange' );
                    } );
                },
                set: function ( strParcelShopID ) {
                    for ( var i = 0; i < e4.checkout.steps.shipping.gls.data.parcelshops.length; i++ ) {
                        e4.checkout.steps.shipping.gls.data.parcelshops[ i ].isSelected = '';
                        if ( e4.checkout.steps.shipping.gls.data.parcelshops[ i ].Number === strParcelShopID ) {
                            var mappingObj = {
                                EcomOrderDeliveryName: e4.checkout.steps.shipping.gls.data.parcelshops[ i ].CompanyName,
                                EcomOrderDeliveryCompany: e4.checkout.steps.shipping.gls.data.parcelshops[ i ].Streetname2,
                                EcomOrderDeliveryAddress: e4.checkout.steps.shipping.gls.data.parcelshops[ i ].Streetname,
                                EcomOrderDeliveryZip: e4.checkout.steps.shipping.gls.data.parcelshops[ i ].ZipCode,
                                EcomOrderDeliveryCity: e4.checkout.steps.shipping.gls.data.parcelshops[ i ].CityName
                            };
                            e4.checkout.steps.shipping.gls.data.parcelshops[ i ].isSelected = true;
                            e4.checkout.steps.shipping.clear();
                            e4.checkout.utils.mapAddress( mappingObj );
                            jQuery( '.js-e-checkout-shippingmethod-gls-id' ).val( e4.checkout.steps.shipping.gls.data.parcelshops[ i ].Number );
                        }
                        jQuery( '.js-e-checkout-shippingmethod-gls-zip' ).data( 'rule-required', false );
                    }
                },
                search: function ( intGlsZip ) {
                    var glsAddress = jQuery( '.js-e-checkout-shippingmethod-gls-address' ).val();
                    jQuery.ajax( {
                        url: '/glslookup.ashx',
                        type: 'POST',
                        beforeSend: function () {
                            jQuery( '.js-e-checkout-step-loading-overlay' ).addClass( 'is-loading' );
                        },
                        data: {
                            count: e4.settings.ecom.checkout.shipping.searchCount,
                            type: glsAddress ? 'ADDRESS' : 'ZIP',
                            street: glsAddress,
                            zipcode: intGlsZip
                        }
                    } )
                          .done( function ( data ) {
                              if ( e4.checkout.debug === true ) {
                                  console.info( data );
                              }
                              e4.checkout.steps.shipping.gls.data = data;
                              jQuery( '.js-e-checkout-step-loading-overlay' ).removeClass( 'is-loading' );
                              e4.checkout.steps.shipping.gls.build();
                          } );
                },
                build: function () {
                    jQuery( '#js-e-checkout-shippingmethod-gls-results' ).html( e4.handlebars.partial.gls( e4.checkout.steps.shipping.gls.data ) ).slideDown( e4.settings.animation.speed, function () {
                        //jQuery( this ).find( '.js-e-checkout-shippingmethod-gls-result-item' ).first().prop(
                        // 'checked', true ).trigger( 'click' );
                        e4.scrollToAnchor.animate( e4.scrollToAnchor.getTarget( '.js-e-checkout-shippingmethod-gls' ) );
                    } );
                }
            }
        },
        payment: {},
        approve: {
            init: function () {
                e4.checkout.steps.approve.termsAndConditions.init();
            },
            show: function () {
                jQuery( '.js-e-checkout-approve-form' ).validate();
            },
            newsletterSubscription: function () {
                jQuery( '.js-e-checkout' ).on( 'change', 'input[name="Co3EspressoEcomOrderSubscribeToNewsletter"]', function () {
                    jQuery( '.js-e-checkout-approve-form' ).find( 'input[name="EcomOrderSubscribeToNewsletter"]' ).val( this.checked === true ? 'true' : '' );
                } ).triggerHandler( 'change' );
            },
            termsAndConditions: {
                init: function () {
                    e4.checkout.steps.approve.termsAndConditions.bindEvents();
                    e4.checkout.steps.approve.termsAndConditions.fetch();
                },
                bindEvents: function () {
                    jQuery( '.js-e-checkout' ).on( 'change', 'input[name="EcomOrderCustomerAccepted"]', function () {
                        jQuery( 'input[name="EcomOrderCustomerAccepted"]' ).prop( 'checked', jQuery( this ).prop( 'checked' ) );
                    } );
                    jQuery( '.js-e-accept-term-and-conditions' ).on( 'click', function () {
                        jQuery( 'input[name="EcomOrderCustomerAccepted"]' ).prop( 'checked', true );
                    } );
                },
                fetch: function () {
                    jQuery.get( e4.settings.ecom.checkout.termsAndConditions, function ( data ) {
                        var strHtml = jQuery( data ).find( '.e-content-main' ).html();
                        jQuery( '.js-e-checkout-modal-terms-and-conditions' ).replaceWith( strHtml );
                    } );
                }
            }
        },
        receipt: {
            init: function () {
                e4.util.hash.remove( 'step' );
                sessionStorage.removeItem( 'e4.checkout.step' );
                var step = {
                    index: 4,
                    name: 'receipt'
                };
                e4.checkout.tracking.step( step );
            }
        }
    },
    tracking: {
        step: function ( objData ) {
            var sikaStepIndex = objData.index + 2;
            var virtualPageview = { 
                'event': 'VirtualPageview',
                'vpevent': 'VirtualPageview',
                'virtualPageURL': '/shop/cart/checkout?step=' + sikaStepIndex + ' ' + objData.name,
                'virtualPageTitle': 'Order Step ' + sikaStepIndex + ' – ' + objData.name
            };
            var checkout = {
                'event': 'checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': {
                            'step': sikaStepIndex
                        }
                    }
                }
            };
            e4.gtm.pushDataLayer( virtualPageview );
            e4.gtm.pushDataLayer( checkout );
        }
    }
};
